<div
  soho-busyindicator
  [style.height]="'100%'"
  [text]="' '"
  [blockUI]="true"
  [displayDelay]="20"
  [transparentOverlay]="true"
  >
  <div class="row form-layout-compact">
    <div class="column" [ngClass]="{'one-third': reportType === 'ReportCopiedFromList', 'one-fourth': reportType === 'ReportCopiedFromReport'}">
      <div class="field">
        <label soho-label for="searchListName">{{ 'ListName' | translate }}</label>
        <input
          name="searchListName"
          data-automation-id="lm-create-report-list-name"
          [(ngModel)]="searchOptions.list.value" (keydown.enter)="onFilterCriteriaChange($event)"
          soho-dropdown soho-field-filter [fieldDropdownDataSet]="comparators"
          (filtered)="onListComparatorChange($event)">
        </div>
      </div>
      <div class="column" [ngClass]="{'one-third': reportType === 'ReportCopiedFromList', 'one-fourth': reportType === 'ReportCopiedFromReport'}">
        <div class="field">
          <label soho-label for="searchTitle">{{ (reportType === 'ReportCopiedFromList' ? 'Title' : 'ListPersonalizationReportNameLabel') | translate }}</label>
          <input
            name="searchTitle"
            data-automation-id="lm-create-report-list-title"
            [(ngModel)]="searchOptions.title.value" (keydown.enter)="onFilterCriteriaChange($event)"
            soho-dropdown soho-field-filter [fieldDropdownDataSet]="comparators"
            (filtered)="onTitleComparatorChange($event)">
          </div>
        </div>
        @if (reportType === 'ReportCopiedFromReport') {
          <div class="one-fourth column">
            <div class="field">
              <label soho-label for="reportOwner">{{ 'Owner' | translate }}</label>
              <input
                name="reportOwner"
                data-automation-id="lm-create-report-list-owner"
                [(ngModel)]="searchOptions.owner.value" (keydown.enter)="onFilterCriteriaChange($event)"
                soho-dropdown soho-field-filter [fieldDropdownDataSet]="comparators"
                (filtered)="onOwnerComparatorChange($event)">
              </div>
            </div>
          }
          <div class="column" [ngClass]="{'one-third': reportType === 'ReportCopiedFromList', 'one-fourth': reportType === 'ReportCopiedFromReport'}">
            <div class="field">
              <label soho-label for="fieldsSelectorType">{{ 'Data' | translate }}</label>
              <select
                id="item-desc"
                name="searchListDataType"
                [attributes]="dataDropdownAttributes"
                [(ngModel)]="searchOptions.dataType"
                (keydown.enter)="onFilterCriteriaChange($event)" (change)="onFilterCriteriaChange($event)"
                soho-dropdown [showSelectAll]="true">
                @for (datatype of dataTypes; track datatype) {
                  <option [value]="datatype.value">{{datatype.text}}</option>
                }
              </select>
            </div>
          </div>
        </div>

        <div class="row form-layout-compact">
          <div soho-datagrid id="lm-create-report-list-grid"
            [ngClass]="{'withoutInstanceSelection': true}" class="ten columns"
            data-automation-id="lm-create-report-list-grid"
            (selected)="onRowSelected($event)"
            [gridOptions]="gridOptions"
            [emptyMessage]="emptyMessage">
          </div>
        </div>
      </div>

